module.exports = __webpack_public_path__ + "static/media/residential.805ebee7.svg";